export enum ESharedCaseFilter {
  ALL = 'ALL',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  UPCOMING = 'UPCOMING',  
}